// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hs-0";
export var assigneeDetails = "_hs-1";
export var assigneeInfo = "_hs-2";
export var dropdownContainer = "_hs-4";
export var dropdownImage = "_hs-5";
export var editAssigneeInfo = "_hs-3";
export var editAssigneeModalContainer = "_hs-6";
export var hidden = "_hs-8";
export var input = "_hs-7";